import { useFieldArray, useFormContext } from "react-hook-form";
import { Button, Flex, Heading, HStack, Stack, Text } from "@chakra-ui/react";
import { DesktopOnly } from "components/BreakpointVisibility";
import { emptyLineItem, RequestContractFormProps } from "./RequestContractForm";
import ContractLineItem from "./ContractLineItem";

const MAX_LINE_ITEMS = 5;

const ContractLineItems = () => {
  const { watch } = useFormContext<RequestContractFormProps>();
  const { fields, append } = useFieldArray<RequestContractFormProps>({
    name: "lineItems",
  });

  const lastItem = watch(`lineItems.${fields.length - 1}`);

  const lastItemInListFilledIn =
    !!lastItem?.shipFrom &&
    !!lastItem?.shipTo &&
    !!lastItem?.salesTerms &&
    !!lastItem?.mode;

  return (
    <Stack spacing={6}>
      <Stack spacing={4}>
        <Heading>
          <Text textStyle="h4">Contract Line Items</Text>
        </Heading>
        <Stack spacing={0}>
          <DesktopOnly>
            <HStack px={4} spacing={4}>
              <Flex flex={1}>Ship From</Flex>
              <Flex flex={1}>Ship To</Flex>
              <Flex flex={1}>Sales Terms</Flex>
              <Flex flex={1}>Mode</Flex>
            </HStack>
          </DesktopOnly>
          <Stack spacing={0}>
            {fields.map((field, index) => (
              <ContractLineItem key={field.id} index={index} />
            ))}
          </Stack>
        </Stack>
      </Stack>
      {fields.length < MAX_LINE_ITEMS ? (
        <Button
          variant="link"
          alignSelf="flex-start"
          isDisabled={!lastItemInListFilledIn}
          onClick={() => lastItemInListFilledIn && append(emptyLineItem)}
        >
          + Add additional line item (up top {MAX_LINE_ITEMS})
        </Button>
      ) : null}
    </Stack>
  );
};

export default ContractLineItems;
